import classNames from 'classnames';

import type * as Pricing from '@/pricing/types';

import { Cell } from './Cell';
import { TitleCell } from './TitleCell';

import styles from './Row.module.scss';

interface Props {
    options: string[];
    row: Pricing.Row;
    className?: string;
}

export function Row({ row, options, className }: Props) {
    return (
        <div className={classNames(styles.row, className)}>
            <TitleCell row={row} />

            <div className={styles.values}>
                {options.map((option) => (
                    <Cell key={option} cell={row.cells[option]} />
                ))}
            </div>
        </div>
    );
}
